module.exports = __webpack_public_path__ + "static/media/8.b1bbc528.png";